var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"srw-container"},[_c('attach-resource-card',{attrs:{"title":"software"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }